import {Endpoints, TFile} from "@brg/api";

const TARGET_SIZE = 600

export const getImgUrlFromList = (images: TFile[]) => {


    if (images) {
        const newImages: TFile[] = JSON.parse(JSON.stringify(images))
        const sorted = newImages.sort((a, b) => a.width - b.width)

        const resized = sorted.find(({ width }) => width >= TARGET_SIZE)
        const original = newImages.find(({ size }) => size === 'original');

        const result = resized || original || newImages[0];

        return `${Endpoints.files}/${result?.url}`;
    }
    return null;
}import {Endpoints, TFile} from "@brg/api";

const TARGET_SIZE = 600

export const getImgUrlFromList = (images: TFile[]) => {


    if (images) {
        const newImages: TFile[] = JSON.parse(JSON.stringify(images))
        const sorted = newImages.sort((a, b) => a.width - b.width)

        const resized = sorted.find(({ width }) => width >= TARGET_SIZE)
        const original = newImages.find(({ size }) => size === 'original');

        const result = resized || original || newImages[0];

        return `${Endpoints.files}/${result?.url}`;
    }
    return null;
}